export default "__VITE_ASSET__BlsjxEBg__"